import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const AboutSection = () => {
  return (
    <div className="about-four about-four--one section-space" id="about">
      <div
        className="about-four__bg"
        style={{ backgroundImage: "url(/images/shapes/about-bg.png)" }}
      ></div>

      <div className="container">
        <div className="row gutter-y-40 align-items-center">
          {/* Left Image Section */}
          <div className="col-lg-6">
            <div
              className="about-four__image wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="150ms"
            >
              <div className="about-four__image__item">
                <img
                  className="d-none d-md-block"
                  src="/images/about/about-1-1.png"
                  alt="About Amruta Travels Bus Service"
                />
                <img
                  className="d-block d-md-none"
                  src="/images/about/about-1-1.webp"
                  alt="About Amruta Travels Bus Service"
                />
              </div>
            </div>
          </div>

          {/* Right Text Section */}
          <div className="col-lg-6">
            <div className="about-four__right">
              <div className="sec-title">
                <div
                  className="sec-title__top wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="150ms"
                >
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">ABOUT AMRUTA TRAVELS</h6>
                </div>

                <h3
                  className="sec-title__title wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  Reliable Bus Rental & Group Travel Services Across Maharashtra
                </h3>
              </div>

              <p
                className="about-four__top__text wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="150ms"
              >
                At <strong>Amruta Travels Pvt Ltd</strong>, we specialize in providing 
                <strong> bus rental services in Pune</strong> for outstation trips, 
                corporate travel, school picnics, and wedding transportation. 
                Our fleet includes <strong>AC and Non-AC buses</strong> of various capacities 
                to ensure a comfortable and safe travel experience for all passengers.
              </p>

              <p
                className="about-four__top__text wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                With over a decade of experience in the travel industry, 
                we’re known for our punctuality, clean and well-maintained vehicles, 
                and courteous drivers. Whether it’s a short city ride or 
                a long-distance group tour, <strong>Amruta Travels</strong> delivers 
                reliable and affordable bus services you can trust.
              </p>

              <div
                className="about-four__bottom wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="150ms"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
